import styled from 'styled-components';

export const PanelCard = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 12px;
  background-color: ${({ theme }) => theme.palette.common.white};
`;

export const PanelHeading = styled.h2`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const PanelSubtext = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

// Groups a label (heading/subtext, button/help) into a tight pairing so it reads
// as one unit rather than spreading across the 20px PanelCard gap.
export const PanelGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Steps = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StepItem = styled.li<{ $done: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: ${({ theme, $done }) => ($done ? theme.palette.text.primary : theme.palette.text.secondary)};
`;

export const StepMarker = styled.span<{ $done: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  border-radius: 50%;
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme, $done }) => ($done ? theme.palette.common.white : theme.palette.text.secondary)};
  background-color: ${({ theme, $done }) => ($done ? theme.palette.primary.main : theme.palette.grey[200])};
`;

export const PanelHelp = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 16px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.tint.primary.subtle};
`;

export const InfoLabel = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const InfoValue = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FieldLabel = styled.label`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const NoticeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
  width: 100%;
  max-width: 560px;
  margin: 48px auto 0;
  padding: 48px 32px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 12px;
  background-color: ${({ theme }) => theme.palette.common.white};
`;

export const NoticeHeadline = styled.h2`
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const NoticeText = styled.p`
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const ReferenceChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.grey[50]};
`;

export const ReferenceValue = styled.span`
  font-family: monospace;
  font-size: 13px;
  color: ${({ theme }) => theme.palette.text.primary};
`;
